export default "__VITE_ASSET__33825b9c__"